import React from 'react';

import PropTypes from 'prop-types';
import {
  Table as QuoteApprovalDashboardTable,
  Thead,
  Tbody,
  Tr,
  Th
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Row from './Row';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Table = ({ pageLayout, data, fetchOrders }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      referenceId,
      businessLegalName,
      orderStatus,
      createdAt,
      updatedAt,
      actions
    }
  } = localizedStrings;

  return (
    <QuoteApprovalDashboardTable>
      <Thead style={{ background: '#e2e2e2' }}>
        <Tr>
          <Th>{referenceId}</Th>
          <Th>{businessLegalName}</Th>
          <Th>{orderStatus}</Th>
          <Th>{createdAt}</Th>
          <Th>{updatedAt}</Th>
          <Th>{actions}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data &&
          data.map((order, index) => (
            <Row
              key={order.id}
              index={index}
              order={order}
              pageLayout={pageLayout}
              fetchOrders={fetchOrders}
            />
          ))}
      </Tbody>
    </QuoteApprovalDashboardTable>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Table;
